// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const SDK_VERSION: string = "0.2.3";

export const DEFAULT_RETRY_POLICY_COUNT = 3;
